import { EyeTypes } from "../config/config";
import store from "../store";

export default class HvfView {
  constructor(exam, image) {
    this.exam = exam;
    this.image = image;

    this.images = [];
    this.osImages = [];
    this.odImages = [];
    this.imagePairs = [];
    this.index = 0;
    this.osImage = null;
    this.odImage = null;
  }

  get maxIndex() {
    return Math.max(this.osImages.length, this.odImages.length) - 1;
  }

  setupView(exams) {
    this.images = store.getters.imagesForExams(exams).sort((a, b) => b.exSrNo - a.exSrNo);  
    this.osImages = this.images.filter(i => i.imgEye === EyeTypes.OS);
    this.odImages = this.images.filter(i => i.imgEye === EyeTypes.OD);

    if (!this.image) this.image = this.images[0];

    this.createImagePairs();
    this.selectInitialImagePair();
  }

  loadImages(){
    return store.dispatch("loadImages_full_thumb", this.images);
  }

  selectImagesByIndex(index){
    if (index < 0) index = 0;
    if (index >= this.maxIndex) index = this.maxIndex;
    this.index = index;
    
    this.odImage = this.imagePairs[index].odImage;
    this.osImage = this.imagePairs[index].osImage;
  }

  createImagePairs() {
    this.imagePairs = [];
  
    if (this.odImages.length >= this.osImages.length) 
    {
      this.odImages.forEach(od => 
      {
        let pair = {odImage: od, osImage: null};

        let osPair = this.osImages.filter(i => i.imgData == od.imgData);
        if (osPair.length > 0) 
        {
          pair.osImage = osPair[0];
          let osIndex = this.osImages.findIndex(object => {
            return object.imgKey == osPair[0].imgKey;
          });
          this.osImages.splice(osIndex, 1);
        }
        this.imagePairs.push(pair);
      });
    }
    else 
    {
      this.osImages.forEach(os => 
      {
        let pair = {odImage: null, osImage: os};

        let odPair = this.odImages.filter(i => i.imgData == os.imgData);
        if (odPair.length > 0) 
        {
          pair.odImage = odPair[0];
          let odIndex = this.odImages.findIndex(object => {
            return object.imgKey == odPair[0].imgKey;
          });
          this.odImages.splice(odIndex, 1);
        }
        this.imagePairs.push(pair);
      });
    }
  }

  selectInitialImagePair() 
  {
    let imgEye = (this.image.imgEye === EyeTypes.OS ? EyeTypes.OS : EyeTypes.OD);
    let selectedPair = this.imagePairs.filter(e => 
      {
        if (imgEye == EyeTypes.OD && e.odImage != null)
          return e.odImage.imgKey == this.image.imgKey;
        else if (imgEye == EyeTypes.OS && e.osImage != null)
          return e.osImage.imgKey == this.image.imgKey;
        else
          return false;
      });
    if (selectedPair.length > 0) 
    {
      let pairIndex = this.imagePairs.indexOf(selectedPair[0]);
      this.odImage = this.imagePairs[pairIndex].odImage;
      this.osImage = this.imagePairs[pairIndex].osImage;
      this.index = pairIndex;
    }
  }

  prev() {
    this.selectImagesByIndex(this.index - 1);
  }

  next() {
    this.selectImagesByIndex(this.index + 1);
  }

  clear(){
    this.exam = null;
    this.images = null;
    this.osImages = null;
    this.odImages = null;
    this.image = null;
    this.osImage = null;
    this.odImage = null;
    this.imagePairs = null;
  }
}